import { render, staticRenderFns } from "./UpdateTemplateAppDialog.vue?vue&type=template&id=2884e594&scoped=true"
import script from "./UpdateTemplateAppDialog.vue?vue&type=script&lang=js"
export * from "./UpdateTemplateAppDialog.vue?vue&type=script&lang=js"
import style0 from "./UpdateTemplateAppDialog.vue?vue&type=style&index=0&id=2884e594&lang=css"
import style1 from "./UpdateTemplateAppDialog.vue?vue&type=style&index=1&id=2884e594&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2884e594",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2884e594')) {
      api.createRecord('2884e594', component.options)
    } else {
      api.reload('2884e594', component.options)
    }
    module.hot.accept("./UpdateTemplateAppDialog.vue?vue&type=template&id=2884e594&scoped=true", function () {
      api.rerender('2884e594', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/templateApp/UpdateTemplateAppDialog.vue"
export default component.exports